export const environmentalData = [
  {
    legislation: [
      "Canadian Environmental Protection Act (CEPA), 1999",
      "Canadian Environmental Assessment Act, 2012",
      "Impact Assessment Act (IAA), 2019",
      "Fisheries Act, R.S.C. 1985",
      "Species at Risk Act (SARA), 2002",
      "Migratory Birds Convention Act, 1994",
      "Canada Wildlife Act, 1985",
      "Canada National Parks Act, 2000",
      "Canada Water Act (R.S.C., 1985, c. C-11)",
      "Arctic Waters Pollution Prevention Act, 1985",
      "Transportation of Dangerous Goods Act, 1992",
      "Pest Control Products Act, 2002",
      "Nuclear Safety and Control Act, 1997",
      "Greenhouse Gas Pollution Pricing Act, 2018",
      "Federal Sustainable Development Act, 2008",
      "Canadian Navigable Waters Act, R.S.C., 1985, c. N-22",
      "Oceans Act (S.C. 1996, c. 31)",
      "Hazardous Products Act, 1985",
      "Environmental Violations Administrative Monetary Penalties Act, 2009",
      "Canada Foundation for Sustainable Development Technology Act, 2001",
      "Canada Oil and Gas Operations Act, 1985",
      "Explosives Act, 1985",
      "Marine Liability Act, 2001",
      "Safe Drinking Water for First Nations Act, 2013",
      "Energy Efficiency Act, 1992",
      "Canadian Energy Regulator Act, 2019",
      "Canadian Net Zero Emissions Accountability Act, 2021",
      "Canada Business Corporations Act (CBCA)",
    ],
    regulations: [
      // Canadian Environmental Protection Act (CEPA), 1999
      "Alberta Equivalency Order (SOR/94-752)",
      "Asbestos Mines and Mills Release Regulations (SOR/90-341)",
      "Benzene in Gasoline Regulations (SOR/97-493)",
      "Boards of Review, Rules of Procedure for (SOR/2003-28)",
      "Certain Products Containing Toxic Substances Regulations (SOR/2025-36)",
      "Chromium Electroplating, Chromium Anodizing and Reverse Etching Regulations (SOR/2009-162)",
      "Circumstances for Granting Waivers Pursuant to Section 147 of the Act, Regulations Prescribing (SOR/2010-138)",
      "Clean Electricity Regulations (SOR/2024-263)",
      "Clean Fuel Regulations (SOR/2022-140)",
      "Concentration of Phosphorus in Certain Cleaning Products Regulations (SOR/89-501)",
      "Contaminated Fuel Regulations (SOR/91-486)",
      "Cross-border Movement of Hazardous Waste and Hazardous Recyclable Material Regulations (SOR/2021-25)",
      "Disposal at Sea Permit Application Regulations (SOR/2014-177)",
      "Disposal at Sea Regulations (SOR/2001-275)",
      "Environmental Emergency Regulations, 2019 (SOR/2019-51)",
      "Export of Substances on the Export Control List Regulations (SOR/2013-88)",
      "Federal Halocarbon Regulations, 2022 (SOR/2022-110)",
      "Formaldehyde Emissions from Composite Wood Products Regulations (SOR/2021-148)",
      "Fuels Information Regulations, No. 1 (C.R.C., c. 407)",
      "Gasoline and Gasoline Blend Dispensing Flow Rate Regulations (SOR/2000-43)",
      "Gasoline Regulations (SOR/90-247)",
      "Heavy-duty Vehicle and Engine Greenhouse Gas Emission Regulations (SOR/2013-24)",
      "Marine Spark-Ignition Engine, Vessel and Off-road Recreational Vehicle Emission Regulations (SOR/2011-10)",
      "Masked Name Regulations (SOR/94-261)",
      "Microbeads in Toiletries Regulations (SOR/2017-111)",
      "Multi-Sector Air Pollutants Regulations (SOR/2016-151)",
      "New Substances Fees Regulations (SOR/2002-374)",
      "New Substances Notification Regulations (Chemicals and Polymers) (SOR/2005-247)",
      "New Substances Notification Regulations (Organisms) (SOR/2005-248)",
      "Off-road Compression-Ignition (Mobile and Stationary) and Large Spark-Ignition Engine Emission Regulations (SOR/2020-258)",
      "Off-Road Small Spark-Ignition Engine Emission Regulations (SOR/2003-355)",
      "On-Road Vehicle and Engine Emission Regulations (SOR/2003-2)",
      "Order Declaring that the Reduction of Carbon Dioxide Emissions from Coal-fired Generation of Electricity Regulations Do Not Apply in Saskatchewan, 2025 (SOR/2024-269)",
      "Ozone-depleting Substances and Halocarbon Alternatives Regulations (SOR/2016-137)",
      "Passenger Automobile and Light Truck Greenhouse Gas Emission Regulations (SOR/2010-201)",
      "PCB Regulations (SOR/2008-273)",
      "Persistence and Bioaccumulation Regulations (SOR/2000-107)",
      "Products Containing Mercury Regulations (SOR/2014-254)",
      "Prohibition of Asbestos and Products Containing Asbestos Regulations (SOR/2018-196)",
      "Prohibition of Certain Toxic Substances Regulations, 2012 (SOR/2012-285)",
      "Prohibition of the Manufacture and Importation of Wheel Weights Containing Lead Regulations (SOR/2023-15)",
      "Provisions of the Regulations Respecting Reduction in the Release of Methane and Certain Volatile Organic Compounds (Upstream Oil and Gas Sector) Do Not Apply in Alberta, Order Declaring that the (SOR/2020-233)",
      "Pulp and Paper Mill Defoamer and Wood Chip Regulations (SOR/92-268)",
      "Pulp and Paper Mill Effluent Chlorinated Dioxins and Furans Regulations (SOR/92-267)",
      "Reduction in the Release of Methane and Certain Volatile Organic Compounds (Upstream Oil and Gas Sector), Regulations Respecting (SOR/2018-66)",
      "Reduction in the Release of Volatile Organic Compounds (Storage and Loading of Volatile Petroleum Liquids) Regulations (SOR/2025-88)",
      "Reduction in the Release of Volatile Organic Compounds Regulations (Petroleum Sector) (SOR/2020-231)",
      "Reduction of Carbon Dioxide Emissions From Coal-Fired Generation of Electricity Regulations (SOR/2012-167)",
      "Reduction of Carbon Dioxide Emissions from Coal-fired Generation of Electricity Regulations Do Not Apply in Nova Scotia, Order Declaring that the (SOR/2014-265)",
      "Regulations Limiting Carbon Dioxide Emissions from Natural Gas-fired Generation of Electricity (SOR/2018-261)",
      "Regulations Respecting Reduction in the Release of Methane and Certain Volatile Organic Compounds (Upstream Oil and Gas Sector) Do Not Apply in British Columbia, 2025, Order Declaring that the (SOR/2025-37)",
      "Regulatory Provisions for Purposes of Enforcement (Canadian Environmental Protection Act, 1999), Regulations Designating (SOR/2012-134)",
      "Release and Environmental Emergency Notification Regulations (SOR/2011-90)",
      "Secondary Lead Smelter Release Regulations (SOR/91-155)",
      "Single-use Plastics Prohibition Regulations (SOR/2022-138)",
      "Solvent Degreasing Regulations (SOR/2003-283)",
      "Storage Tank Systems for Petroleum Products and Allied Petroleum Products Regulations (SOR/2008-197)",
      "Sulphur in Diesel Fuel Regulations (SOR/2002-254)",
      "Sulphur in Gasoline Regulations (SOR/99-236)",
      "Tetrachloroethylene (Use in Dry Cleaning and Reporting Requirements) Regulations (SOR/2003-79)",
      "Tributyltetradecylphosphonium Chloride Regulations (SOR/2000-66)",
      "Virtual Elimination List (SOR/2006-298)",
      "Volatile Organic Compound (VOC) Concentration Limits for Architectural Coatings Regulations (SOR/2009-264)",
      "Volatile Organic Compound (VOC) Concentration Limits for Automotive Refinishing Products Regulations (SOR/2009-197)",
      "Volatile Organic Compound Concentration Limits for Certain Products Regulations (SOR/2021-268)",
      // Canadian Environmental Assessment Act, 2012
      "Cost Recovery Regulations (SOR/2012-146)",
      "Physical Activities, Regulations Designating (SOR/2012-147)",
      // Impact Assessment Act (IAA), 2019
      "Information and Management of Time Limits Regulations (SOR/2019-283)",
      "Order Designating Certain Excluded Classes of Projects (SOR/2025-60)",
      "Physical Activities Regulations (SOR/2019-285)",
      // Fisheries Act, R.S.C. 1985
      "Aboriginal Communal Fishing Licences Regulations (SOR/93-332)",
      "Alberta Fishery Regulations, 1998 (SOR/98-246)",
      "Aquaculture Activities Regulations (SOR/2015-177)",
      "Aquatic Invasive Species Regulations (SOR/2015-121)",
      "Atlantic Fishery Regulations, 1985 (SOR/86-21)",
      "Authorizations Concerning Fish and Fish Habitat Protection Regulations (SOR/2019-286)",
      "Ballast Water Regulations (SOR/2021-120)",
      "British Columbia Sport Fishing Regulations, 1996 (SOR/96-137)",
      "Conditions for Making Regulations Under Subsection 36(5.2) of the Fisheries Act, Regulations Establishing (SOR/2014-91)",
      "Deposit Out of the Normal Course of Events Notification Regulations (SOR/2011-91)",
      "Dogfish Exemption Notice (C.R.C., c. 836)",
      "Experimental Lakes Area Research Activities Regulations (SOR/2014-95)",
      "Fish Toxicant Regulations (SOR/88-258)",
      "Fishery (General) Regulations (SOR/93-53)",
      "Foreign Vessel Fishing Regulations (C.R.C., c. 815)",
      "Management of Contaminated Fisheries Regulations (SOR/90-351)",
      "Manitoba Fishery Regulations, 1987 (SOR/87-509)",
      "Marine Mammal Regulations (SOR/93-56)",
      "Maritime Provinces Fishery Regulations (SOR/93-55)",
      "Meat and Poultry Products Plant Liquid Effluent Regulations (C.R.C., c. 818)",
      "Metal and Diamond Mining Effluent Regulations (SOR/2002-222)",
      "Newfoundland and Labrador Fishery Regulations (SOR/78-443)",
      "Northwest Territories Fishery Regulations (C.R.C., c. 847)",
      "Ontario Fishery Regulations, 1989 (SOR/89-93)",
      "Ontario Fishery Regulations, 2007 (SOR/2007-237)",
      "Order Declaring that the Wastewater Systems Effluent Regulations Do Not Apply in Quebec (SOR/2018-194)",
      "Order Designating the Minister of the Environment as the Minister Responsible for the Administration and Enforcement of Subsections 36(3) to (6) of the Fisheries Act (SI/2014-21)",
      "Pacific Aquaculture Regulations (SOR/2010-270)",
      "Pacific Fishery Management Area Regulations, 2007 (SOR/2007-77)",
      "Pacific Fishery Regulations, 1993 (SOR/93-54)",
      "Pacific Hake Exemption Notice (SOR/86-750)",
      "Petroleum Refinery Liquid Effluent Regulations (C.R.C., c. 828)",
      "Possession and Export of Elvers Regulations (SOR/2024-237)",
      "Potato Processing Plant Liquid Effluent Regulations (C.R.C., c. 829)",
      "Pulp and Paper Effluent Regulations (SOR/92-269)",
      "Quebec Fishery Regulations, 1990 (SOR/90-214)",
      "Roe Herring Exemption Notice (C.R.C., c. 837)",
      "Saskatchewan Fishery Regulations, 1995 (SOR/95-233)",
      "Wastewater Systems Effluent Regulations (SOR/2012-139)",
      "Wastewater Systems Effluent Regulations Do Not Apply in Yukon, Order Declaring that the (SOR/2014-279)",
      "Yukon Territory Fishery Regulations (C.R.C., c. 854)",
      // Species at Risk Act (SARA), 2002
      "Critical Habitat of Atlantic Whitefish (Coregonus huntsmani) Order (SOR/2018-182)",
      "Critical Habitat of Carmine Shiner (Notropis percobromus) Order (SOR/2018-183)",
      "Critical Habitat of the Atlantic Mud-piddock (Barnea truncata) Order (SOR/2023-221)",
      "Critical Habitat of the Atlantic Salmon (Salmo salar) Inner Bay of Fundy Population Order (SOR/2019-322)",
      "Critical Habitat of the Barrens Willow (Salix jejuna) Order (SOR/2019-236)",
      "Critical Habitat of the Beluga Whale (Delphinapterus leucas) St. Lawrence Estuary Population Order (SOR/2017-263)",
      "Critical Habitat of the Black Redhorse (Moxostoma duquesnei) Order (SOR/2022-235)",
      "Critical Habitat of the Bull Trout (Salvelinus confluentus) Saskatchewan-Nelson Rivers Populations Order (SOR/2021-31)",
      "Critical Habitat of the Cerulean Warbler (Setophaga cerulea) Order (SOR/2022-97)",
      "Critical Habitat of the Coastrange Sculpin (Cottus aleuticus) Cultus Population Order (SOR/2019-3)",
      "Critical Habitat of the Copper Redhorse (Moxostoma hubbsi) Order (SOR/2021-95)",
      "Critical Habitat of the Eastern Sand Darter (Ammocrypta pellucida) Ontario Populations Order (SOR/2017-265)",
      "Critical Habitat of the Eastern Sand Darter (Ammocrypta pellucida) Quebec Populations Order (SOR/2018-159)",
      "Critical Habitat of the Fawnsfoot (Truncilla donaciformis) Order (SOR/2022-216)",
      "Critical Habitat of the Fernald’s Braya (Braya fernaldii) Order (SOR/2021-12)",
      "Critical Habitat of the Gattinger’s Agalinis (Agalinis gattingeri) Order (SOR/2022-4)",
      "Critical Habitat of the Harbour Seal Lacs des Loups Marins subspecies (Phoca vitulina mellonae) Order (SOR/2018-268)",
      "Critical Habitat of the Hotwater Physa (Physella wrighti) Order (SOR/2019-21)",
      "Critical Habitat of the Kidneyshell (Ptychobranchus fasciolaris) Order (SOR/2019-309)",
      "Critical Habitat of the Killer Whale (Orcinus orca) Northeast Pacific Northern Resident Population Order (SOR/2018-279)",
      "Critical Habitat of the Killer Whale (Orcinus orca) Northeast Pacific Southern Resident Population Order (SOR/2018-278)",
      "Critical Habitat of the Lake Chubsucker (Erimyzon sucetta) Order (SOR/2018-156)",
      "Critical Habitat of the Lilliput (Toxolasma parvum) Order (SOR/2022-215)",
      "Critical Habitat of the Misty Lake Lentic Threespine Stickleback (Gasterosteus aculeatus) Order (SOR/2018-208)",
      "Critical Habitat of the Misty Lake Lotic Threespine Stickleback (Gasterosteus aculeatus) Order (SOR/2018-209)",
      "Critical Habitat of the Nooksack Dace (Rhinichthys cataractae ssp.) Order (SOR/2016-82)",
      "Critical Habitat of the North Atlantic Right Whale (Eubalaena glacialis) Order (SOR/2017-262)",
      "Critical Habitat of the Northern Abalone (Haliotis kamtschatkana) Order (SOR/2017-266)",
      "Critical Habitat of the Northern Bottlenose Whale (Hyperoodon ampullatus) Scotian Shelf Population Order (SOR/2018-157)",
      "Critical Habitat of the Northern Madtom (Noturus stigmosus) Order (SOR/2016-81)",
      "Critical Habitat of the Northern Riffleshell (Epioblasma torulosa rangiana) Order (SOR/2019-327)",
      "Critical Habitat of the Northern Wolffish (Anarhichas denticulatus) Order (SOR/2020-185)",
      "Critical Habitat of the Paxton Lake Benthic Threespine Stickleback (Gasterosteus aculeatus) Order (SOR/2020-25)",
      "Critical Habitat of the Paxton Lake Limnetic Threespine Stickleback (Gasterosteus aculeatus) Order (SOR/2020-26)",
      "Critical Habitat of the Pugnose Minnow (Opsopoeodus emiliae) Order (SOR/2022-236)",
      "Critical Habitat of the Pugnose Shiner (Notropis anogenus) Order (SOR/2019-326)",
      "Critical Habitat of the Rainbow Smelt (Osmerus mordax) Lake Utopia Small-Bodied Population Order (SOR/2019-310)",
      "Critical Habitat of the Rainbow Trout (Oncorhynchus mykiss) Athabasca River Populations Order (SOR/2021-32)",
      "Critical Habitat of the Rayed Bean (Villosa fabalis) Order (SOR/2019-330)",
      "Critical Habitat of the Redside Dace (Clinostomus elongatus) Order (SOR/2025-4)",
      "Critical Habitat of the Rocky Mountain Sculpin (Cottus sp.) Eastslope Populations Order (SOR/2017-267)",
      "Critical Habitat of the Roseate Tern (Sterna dougallii) Order (SOR/2016-281)",
      "Critical Habitat of the Round Hickorynut (Obovaria subrotunda) Order (SOR/2019-308)",
      "Critical Habitat of the Round Pigtoe (Pleurobema sintoxia) Order (SOR/2019-328)",
      "Critical Habitat of the Salamander Mussel (Simpsonaias ambigua) Order (SOR/2019-331)",
      "Critical Habitat of the Salish Sucker (Catostomus catostomus ssp.) Order (SOR/2019-274)",
      "Critical Habitat of the Silver Shiner (Notropis photogenis) Order (SOR/2023-39)",
      "Critical Habitat of the Snuffbox (Epioblasma triquetra) Order (SOR/2019-329)",
      "Critical Habitat of the Speckled Dace (Rhinichthys osculus) Order (SOR/2018-218)",
      "Critical Habitat of the Spotted Gar (Lepisosteus oculatus) Order (SOR/2024-195)",
      "Critical Habitat of the Spotted Wolffish (Anarhichas minor) Order (SOR/2020-186)",
      "Critical Habitat of the Spring Cisco (Coregonus sp.) Order (SOR/2018-158)",
      "Critical Habitat of the Striped Bass (Morone saxatilis) St. Lawrence River Population Order (SOR/2022-2)",
      "Critical Habitat of the Threehorn Wartyback (Obliquaria reflexa) Order (SOR/2022-217)",
      "Critical Habitat of the Vananda Creek Benthic Threespine Stickleback (Gasterosteus aculeatus) Order (SOR/2020-27)",
      "Critical Habitat of the Vananda Creek Limnetic Threespine Stickleback (Gasterosteus aculeatus) Order (SOR/2020-28)",
      "Critical Habitat of the Vancouver Lamprey (Entosphenus macrostomus) Order (SOR/2020-29)",
      "Critical Habitat of the Western Brook Lamprey (Lampetra richardsoni) Morrison Creek Population Order (SOR/2019-123)",
      "Critical Habitat of the Western Chorus Frog (Pseudacris triseriata) Great Lakes / St. Lawrence – Canadian Shield Population Order (SOR/2018-169)",
      "Critical Habitat of the Western Silvery Minnow (Hybognathus argyritis) Order (SOR/2019-2)",
      "Critical Habitat of the Westslope Cutthroat Trout (Oncorhynchus clarkii lewisi) Alberta Population Order (SOR/2015-241)",
      "Critical Habitat of the White Sturgeon (Acipenser transmontanus) Kootenay River Population Order (SOR/2016-86)",
      "Critical Habitat of the White Sturgeon (Acipenser transmontanus) Nechako River Population Order (SOR/2024-21)",
      "Critical Habitat of the White Sturgeon (Acipenser transmontanus) Upper Columbia River Population Order (SOR/2016-85)",
      "Critical Habitat of the White Sturgeon (Acipenser transmontanus) Upper Fraser River Population Order (SOR/2016-83)",
      "Critical Habitat of the Woodland Caribou (Rangifer tarandus caribou) Boreal Population Order (SOR/2019-188)",
      "Decisions not to add Certain Species to the List of Endangered Species, Order Giving Notice of (SI/2006-110)",
      "Emergency Order for the Protection of the Greater Sage-Grouse (SOR/2013-202)",
      "Emergency Order for the Protection of the Western Chorus Frog (Great Lakes / St. Lawrence — Canadian Shield Population) (SOR/2016-211)",
      "Emergency Order for the Protection of the Western Chorus Frog Great Lakes / St. Lawrence — Canadian Shield Population (Longueuil) (SOR/2021-231)",
      "Exemption Order for Certain Licences, Authorizations and Documents (Bull Trout (Saskatchewan-Nelson Rivers Populations)) (SOR/2019-288)",
      "Exemption Order for Certain Licences, Authorizations and Documents (Rainbow Trout (Athabasca River Populations)) (SOR/2019-289)",
      "Exemption Order for Certain Licences, Authorizations and Documents (Westslope Cutthroat Trout (Alberta Population)) (SOR/2013-35)",
      "Exemption Order for Certain Licences, Authorizations and Documents (White Sturgeon) (SOR/2006-190)",
      "Extending the Time for the Assessment of the Status of Wildlife Species, Order (SOR/2006-115)",
      "Extending the Time for the Assessment of the Status of Wildlife Species, Order (SOR/2003-215)",
      "List of Wildlife Species at Risk (Decision Not To Add or Referral Back to COSEWIC) Order (SI/2009-20)",
      "List of Wildlife Species at Risk (Decisions Not to Add Certain Species) Order (SI/2019-66)",
      "List of Wildlife Species at Risk (Decisions Not to Add Certain Species) Order (SI/2012-45)",
      "List of Wildlife Species at Risk (Decisions Not to Add Certain Species) Order (SI/2010-14)",
      "List of Wildlife Species at Risk (Decisions Not to Add Certain Species) Order (SI/2017-24)",
      "List of Wildlife Species at Risk (Decisions Not to Add Certain Species) Order (SI/2013-27)",
      "List of Wildlife Species at Risk (referral back to COSEWIC) Order (SI/2018-17)",
      "List of Wildlife Species at Risk (referral back to COSEWIC) Order (SI/2021-58)",
      "List of Wildlife Species at Risk (referral back to COSEWIC) Order (SI/2017-29)",
      "List of Wildlife Species at Risk (referral back to COSEWIC) Order (SI/2021-33)",
      "List of Wildlife Species at Risk (referral back to COSEWIC) Order (SI/2022-7)",
      "List of Wildlife Species at Risk (referral back to COSEWIC) Order (SI/2019-13)",
      "List of Wildlife Species at Risk (referral back to COSEWIC) Order (SI/2013-28)",
      "Order Acknowledging Receipt of the Assessment Done Pursuant to Subsection 23(1) of the Act (SI/2005-115)",
      "Order Acknowledging Receipt of the Assessment Done Pursuant to Subsection 23(1) of the Act (SI/2021-32)",
      "Order Acknowledging Receipt of the Assessment Done Pursuant to Subsection 23(1) of the Act (SI/2023-66)",
      "Order Acknowledging Receipt of the Assessment Done Pursuant to Subsection 23(1) of the Act (SI/2011-11)",
      "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2022-27)",
      "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2017-30)",
      "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2008-70)",
      "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2010-76)",
      "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2016-55)",
      "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2017-72)",
      "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2020-12)",
      "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2016-49)",
      "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2007-57)",
      "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2005-71)",
      "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2019-12)",
      "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2016-31)",
      "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2004-138)",
      "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2010-42)",
      "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2012-46)",
      "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2018-112)",
      "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2017-17)",
      "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2020-61)",
      "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2022-26)",
      "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2018-40)",
      "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2021-6)",
      "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Species at Risk Act (SI/2004-48)",
      "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 28(1) of the Act (SI/2019-72)",
      "Order Acknowledging Receipt of the Assessments Done Pursuant to Subsection 23(1) of the Act (SI/2011-91)",
      "Order Acknowledging Receipt of the Assessments Done Under Subsection 23(1) of the Act (SI/2023-13)",
      "Order Acknowledging Receipt of the Assessments Done Under Subsection 23(1) of the Species at Risk Act (Certain Wildlife Species of Red Knot and Four Other Wildlife Species) (SI/2024-65)",
      "Order Acknowledging Receipt of the Assessments Done Under Subsection 23(1) of the Species at Risk Act (Chestnut-collared Longspur and Nine Other Wildlife Species) (SI/2023-75)",
      "Order Declining to make an Emergency Order for the protection of the Killer Whale Northeast Pacific Southern Resident Population (SI/2018-102)",
      "Order Giving Notice of Decisions not to add Certain Species to the List of Endangered Species (SI/2007-115)",
      "Order Giving Notice of Decisions not to add Certain Species to the List of Endangered Species (SI/2005-72)",
      "Order Giving Notice of Decisions not to add Certain Species to the List of Endangered Species (SI/2005-2)",
      "Order Giving Notice of Decisions not to add Certain Species to the List of Endangered Species (SI/2006-61)",
      "Order Giving Notice of Decisions Not to Add Certain Species to the List of Endangered Species (SI/2011-56)",
      "Permits Authorizing an Activity Affecting Listed Wildlife Species Regulations (SOR/2013-140)",
      // Migratory Birds Convention Act, 1994
      "Designation of Regulatory Provisions for Purposes of Enforcement (Migratory Birds Convention Act, 1994) Regulations (SOR/2017-108)",
      "Migratory Bird Sanctuary Regulations (C.R.C., c. 1036)",
      "Migratory Birds Regulations, 2022 (SOR/2022-105)",
      // Canada Wildlife Act, 1985
      {
        name: "Assigning to the Minister of the Environment the Administration, Management and Control of Certain Public Lands",
        subRegulations: [
          "Assigning the Administration, Management and Control of Certain Lands from the Minister of Indian Affairs and Northern Development to the Minister of the Environment (SI/86-150)",
          "Assigning to the Minister of the Environment the Administration, Management and Control of Certain Public Lands (SI/85-142)",
          "Assigning to the Minister of the Environment the Administration, Management and Control of Certain Public Lands (SI/82-30)",
          "Assigning to the Minister of the Environment the Administration, Management and Control of Certain Public Lands (SI/80-114)",
          "Assigning to the Minister of the Environment the Administration, Management and Control of Certain Public Lands (SI/81-90)",
          "Assigning to the Minister of the Environment the Administration, Management and Control of Certain Public Lands (SI/80-129)",
          "Assigning to the Minister of the Environment, the Administration, Management and Control of Certain Public Lands (SI/84-62)",
          "Assigning to the Minister of the Environment, the Administration, Management and Control of Certain Public Lands (SI/82-197)",
          "Assigning to the Minister of the Environment, the Administration, Management and Control of Certain Public Lands (SI/85-37)",
          "Assigning to the Minister of the Environment, the Administration, Management and Control of Certain Public Lands (SI/84-77)",
          "Order Assigning to the Minister of the Environment the Administration of Certain Public Lands (SI/95-56)",
          "Order Assigning to the Minister of the Environment the Administration of Certain Public Lands (SI/98-103)",
          "Order Assigning to the Minister of the Environment the Administration, Management and Control of Certain Public Lands (SI/88-138)",
          "Order Assigning to the Minister of the Environment the Administration, Management and Control of Certain Public Lands (SI/89-151)",
          "Order Assigning to the Minister of the Environment, the Administration of Certain Public Lands (SI/95-42)",
          "Order Assigning to the Minister of the Environment, the Administration, Management and Control of Certain Public Lands (SI/92-107)",
          "Order Authorizing the Minister of the Environment to Exercise, with the Concurrence of the Minister of National Defence, the Administration of Certain Public Lands (SI/2003-93)",
        ],
      },
      "Designation of Regulatory Provisions for Purposes of Enforcement (Canada Wildlife Act) Regulations (SOR/2017-107)",
      "Scott Islands Protected Marine Area Establishment Order (SI/2018-44)",
      "Scott Islands Protected Marine Area Regulations (SOR/2018-119)",
      "Wildlife Area Regulations (C.R.C., c. 1609)",
      // Canada National Parks Act, 2000
      "Boundaries of the Town of Banff in Banff National Park and Adding a Description of the Boundaries as Schedule IV to the Act, Order Fixing the (SOR/90-45)",
      "Gros Morne National Park of Canada Snowshoe Hare Regulations (SOR/2005-205)",
      "Gros Morne National Park of Canada Timber Harvesting Regulations (SOR/2005-204)",
      "Gwaii Haanas National Park Reserve Order (SOR/96-93)",
      "Mingan Archipelago National Park Reserve of Canada Snowshoe Hare Regulations (SOR/2004-301)",
      "National Historic Parks General Regulations (SOR/82-263)",
      "National Historic Parks Wildlife and Domestic Animals Regulations (SOR/81-613)",
      "National Historic Sites of Canada Order (C.R.C., c. 1112)",
      "National Parks Cemetery Regulations (SOR/83-677)",
      "National Parks General Regulations (SOR/78-213)",
      "National Parks Highway Traffic Regulations (C.R.C., c. 1126)",
      "National Parks of Canada Aircraft Access Regulations (SOR/97-150)",
      "National Parks of Canada Businesses Regulations (SOR/98-455)",
      "National Parks of Canada Camping Regulations (SOR/80-127)",
      "National Parks of Canada Domestic Animals Regulations (SOR/98-177)",
      "National Parks of Canada Fire Protection Regulations (SOR/80-946)",
      "National Parks of Canada Fishing Regulations (C.R.C., c. 1120)",
      "National Parks of Canada Garbage Regulations (SOR/80-217)",
      "National Parks of Canada Land Use Planning Regulations (SOR/2024-230)",
      "National Parks of Canada Lease and Licence of Occupation Regulations (SOR/92-25)",
      "National Parks of Canada Water and Sewer Regulations (C.R.C., c. 1134)",
      "National Parks of Canada Wilderness Area Declaration Regulations (SOR/2000-387)",
      "National Parks Town, Visitor Centre and Resort Subdivision Designation Regulations (SOR/91-8)",
      "National Parks Wildlife Regulations (SOR/81-401)",
      "Wapusk National Park of Canada Park Use Regulations (SOR/2010-67)",
      "Wood Buffalo National Park Game Regulations (SOR/78-830)",
      // Arctic Waters Pollution Prevention Act, 1985
      {
        name: "Arctic Waters Pollution Prevention Regulations",
        subRegulations: [
          "Arctic Shipping Pollution Prevention Regulations (C.R.C., c. 353)",
          "Arctic Waters Experimental Pollution Regulations, 1978 (SOR/78-417)",
          "Arctic Waters Experimental Pollution Regulations, 1979 (SOR/80-9)",
          "Arctic Waters Experimental Pollution Regulations, 1982 (Dome Petroleum) (SOR/82-276)",
          "Arctic Waters Experimental Pollution Regulations, 1982 (Dome Petroleum) (SOR/82-832)",
          "Arctic Waters Pollution Prevention Regulations (C.R.C., c. 354)",
        ],
      },
      {
        name: "Navigation Regulations",
        subRegulations: [
          "Charts and Nautical Publications Regulations, 1995 (SOR/95-149)",
          "Navigation Safety Regulations (SOR/2005-134)",
          "Ship Station (Radio) Regulations, 1999 (SOR/2000-260)",
          "Shipping Safety Control Zones Order (C.R.C., c. 356)",
          "Steering Appliances and Equipment Regulations (SOR/83-810)",
        ],
      },
      "Governor in Council Authority Delegation Order (C.R.C., c. 355)",
      // Transportation of Dangerous Goods Act, 1992
      "Transportation of Dangerous Goods by Rail Security Regulations (SOR/2019-113)",
      "Transportation of Dangerous Goods Regulations (SOR/2001-286)",
      // Pest Control Products Act, 2002
      "Biocides Regulations [Not in force] (SOR/2024-110)",
      "List of Pest Control Product Formulants and Contaminants of Health or Environmental Concern (SI/2005-114)",
      "Pest Control Products Fees and Charges Regulations (SOR/2017-9)",
      "Pest Control Products Incident Reporting Regulations (SOR/2006-260)",
      "Pest Control Products Regulations (SOR/2006-124)",
      "Pest Control Products Sales Information Reporting Regulations (SOR/2006-261)",
      "Review Panel Regulations (SOR/2008-22)",
      // Nuclear Safety and Control Act, 1997
      "Administrative Monetary Penalties Regulations (Canadian Nuclear Safety Commission) (SOR/2013-139)",
      "Canadian Nuclear Safety Commission By-laws (SOR/2000-212)",
      "Canadian Nuclear Safety Commission Cost Recovery Fees Regulations (SOR/2003-212)",
      "Canadian Nuclear Safety Commission Rules of Procedure (SOR/2000-211)",
      "Class I Nuclear Facilities Regulations (SOR/2000-204)",
      "Class II Nuclear Facilities and Prescribed Equipment Regulations (SOR/2000-205)",
      "Directive to the Canadian Nuclear Safety Commission Regarding the Health of Canadians (SOR/2007-282)",
      "General Nuclear Safety and Control Regulations (SOR/2000-202)",
      "Nuclear Non-proliferation Import and Export Control Regulations (SOR/2000-210)",
      "Nuclear Security Regulations (SOR/2000-209)",
      "Nuclear Substances and Radiation Devices Regulations (SOR/2000-207)",
      "Packaging and Transport of Nuclear Substances Regulations, 2015 (SOR/2015-145)",
      "Radiation Protection Regulations (SOR/2000-203)",
      "Uranium Mines and Mills Regulations (SOR/2000-206)",
      // Greenhouse Gas Pollution Pricing Act, 2018
      "Canadian Greenhouse Gas Offset Credit System Regulations (SOR/2022-111)",
      "Fuel Charge Regulations (2018, c. 12, s. 187)",
      "Output-Based Pricing System Regulations (SOR/2019-266)",
      // Canadian Navigable Waters Act, R.S.C., 1985, c. N-22
      "Canadian Navigable Waters Act Fees Regulations (SOR/2024-148)",
      "Ferry Cable Regulations (SOR/86-1026)",
      "Major Works Order (SOR/2019-320)",
      "Minor Works Order (SOR/2021-170)",
      "Navigable Waters Bridges Regulations (C.R.C., c. 1231)",
      "Navigable Waters Works Regulations (C.R.C., c. 1232)",
      {
        name: "Exemptions from Section 22 and 23 of the Canadian Navigable Waters Act",
        subRegulations: [
          "Order Exempting Certain Navigable Waters Located in Quebec from the Application of Section 23 of the Canadian Navigable Waters Act (SOR/2023-213)",
          "Order Exempting Kapisikama Lake, Located in Quebec, from the Application of Section 23 of the Canadian Navigable Waters Act (SOR/2024-102)",
          "Proclamation Exempting the Mink Arm portion of South McMahon Lake from the Operation of Section 22 of the Act (SOR/2013-141)",
          "Proclamation Exempting the Waters of Lake Pignac and Lake B from the Operation of Section 22 of the Act (SOR/2013-142)",
          "Proclamation Exempting the Waters of Sandy Pond from the Operation of Section 22 of the Navigable Waters Protection Act (SOR/2009-202)",
          "Proclamation Exempting Tom MacKay Lake from the Operation of Section 22 of the Act (SOR/2005-226)",
        ],
      },
      // Oceans Act (S.C. 1996, c. 31)
      "Anguniaqvia niqiqyuam Marine Protected Areas Regulations (SOR/2016-280)",
      "Banc-des-Américains Marine Protected Area Regulations (SOR/2019-50)",
      "Basin Head Marine Protected Area Regulations (SOR/2005-293)",
      "Bowie Seamount Marine Protected Area Regulations (SOR/2008-124)",
      "Certain Marine Carriers Remission Order, 2011 (SI/2011-66)",
      "Confederation Bridge Area Provincial (P.E.I.) Laws Application Regulations (SOR/97-375)",
      {
        name: "Fishing Zones of Canada Orders",
        subRegulations: [
          "Fishing Zones of Canada (Zone 6) Order (C.R.C., c. 1549)",
          "Fishing Zones of Canada (Zones 1, 2 and 3) Order (C.R.C., c. 1547)",
          "Fishing Zones of Canada (Zones 4 and 5) Order (C.R.C., c. 1548)",
        ],
      },
      "Gilbert Bay Marine Protected Area Regulations (SOR/2005-295)",
      "Gully Marine Protected Area Regulations (SOR/2004-112)",
      "Hecate Strait and Queen Charlotte Sound Glass Sponge Reefs Marine Protected Areas Regulations (SOR/2017-15)",
      "Laurentian Channel Marine Protected Area Regulations (SOR/2019-105)",
      "Musquash Estuary Marine Protected Area Regulations (SOR/2006-354)",
      "Order No. 2 Designating the Tuvaijuittuq Marine Protected Area (SOR/2024-165)",
      "St. Anns Bank Marine Protected Area Regulations (SOR/2017-106)",
      "Tang.ɢwan — ḥačxʷiqak — Tsigis Marine Protected Area Regulations (SOR/2024-122)",
      "Tarium Niryutait Marine Protected Areas Regulations (SOR/2010-190)",
      {
        name: "Territorial Sea Geographical Coordinates Orders",
        subRegulations: [
          "Territorial Sea Geographical Coordinates (Area 7) Order (SOR/85-872)",
          "Territorial Sea Geographical Coordinates Order (C.R.C., c. 1550)",
        ],
      },
      // Hazardous Products Act, 1985
      {
        name: "Repealed Hazardous Products Regulations",
        subRegulations: [
          "Children’s Jewellery Regulations [Repealed] (SOR/2005-132)",
          "Controlled Products Regulations [Repealed] (SOR/88-66)",
          "Cribs and Cradles Regulations [Repealed] (SOR/86-962)",
          "Hazardous Products (Booster Cushions) Regulations [Repealed] (SOR/89-446)",
          "Hazardous Products (Child Restraint Systems) Regulations [Repealed] (SOR/88-151)",
          "Hazardous Products (Children’s Sleepwear) Regulations [Repealed] (SOR/87-443)",
          "Hazardous Products (Crocidolite Asbestos) Regulations [Repealed] (SOR/89-440)",
          "Hazardous Products (Lighters) Regulations [Repealed] (SOR/89-514)",
          "Hazardous Products (Toys) Regulations [Repealed] (C.R.C., c. 931)",
          "Ingredient Disclosure List [Repealed] (SOR/88-64)",
          "Safety Glass Regulations [Repealed] (C.R.C., c. 933)",
        ],
      },
      // Canada Oil and Gas Operations Act, 1985
      "Canada Oil and Gas Certificate of Fitness Regulations (SOR/96-114)",
      "Canada Oil and Gas Diving Regulations (SOR/88-600)",
      "Canada Oil and Gas Drilling and Production Regulations (SOR/2009-315)",
      "Canada Oil and Gas Geophysical Operations Regulations (SOR/96-117)",
      "Canada Oil and Gas Installations Regulations (SOR/96-118)",
      "Canada Oil and Gas Operations Administrative Monetary Penalties Regulations (SOR/2016-25)",
      "Canada Oil and Gas Operations Financial Requirements Regulations (SOR/2016-26)",
      "Canada Oil and Gas Operations Regulations (SOR/83-149)",
      "List of Spill-treating Agents (Canada Oil and Gas Operations Act), Regulations Establishing a (SOR/2016-108)",
      "Navigation Safety Regulations, 2020 (SOR/2020-216)",
      "Oil and Gas Spills and Debris Liability Regulations (SOR/87-331)",
      "Polar Bear Pass Withdrawal Order (SOR/84-409)",
      // Explosives Act, 1985
      "Explosives Regulations, 2013 (SOR/2013-211)",
      // Marine Liability Act, 2001
      "Compulsory Insurance for Ships Carrying Passengers, Regulations Respecting (SOR/2018-245)",
      "Marine Liability and Information Return Regulations (SOR/2016-307)",
      // Energy Efficiency Act, 1992
      "Energy Efficiency Regulations, 2016 (SOR/2016-311)",
      // Canadian Energy Regulator Act, 2019
      {
        name: "Canadian Energy Regulator Regulations",
        subRegulations: [
          "Canada Offshore Renewable Energy Regulations (SOR/2024-272)",
          "Circumstances for Excluding Periods from Time Limits Regulations (SOR/2019-348)",
          "International and Interprovincial Power Line Damage Prevention Regulations – Obligations of Holders of Permits and Certificates (SOR/2020-49)",
          "International and Interprovincial Power Line Damage Prevention Regulations — Authorizations (SOR/2019-347)",
          "Order Designating the Minister of Natural Resources, a member of the Queen’s Privy Council for Canada, as the Minister for the purposes of the two Acts (SI/2019-65)",
          "Regulations Amending the Pipeline Financial Requirements Regulations (SOR/2021-134)",
        ],
      },
      // Canadian Net Zero Emissions Accountability Act, 2021
      "2030 Emissions Reduction Plan (ERP)",
      "Cross-border Movement of Hazardous Waste and Hazardous Recyclable Material Regulations (SOR/2021-25)",
    ],
  },
];

export const defaultData = [
  {
    name: "Alberta",
    legislation: [
      "Environmental Protection and Enhancement Act (EPEA), 1992",
      "Water Act, 1999",
      "Climate Change and Emissions Management Act, 2003",
      "Public Lands Act, 2000",
      "Forests Act, R.S.A. 2000, c. F-22",
      "Mines and Minerals Act, 2000",
      "Oil Sands Conservation Act, 2000",
      "Alberta Land Stewardship Act (ALSA), 2009",
      "Emissions Management and Climate Resilience Act, 2023",
      "Wildlife Act, 1984, R.S.A. 2000, c. W-10",
      "Fisheries (Alberta) Act, R.S.A. 2000, c. F-16",
      "Coal Conservation Act, R.S.A. 2000, c. C-17",
      "Oil and Gas Conservation Act, R.S.A. 2000, c. O-6",
      "Mineral Resource Development Act, 2021, c M-16.8",
      "Gas Resources Preservation Act, R.S.A. 2000, c. G-4",
      "Renewable Electricity Act, 2016",
    ],
    regulations: [
      {
        name: "Air Management in Alberta",
        citation:
          "[1] Air Policy Sector, “Air Management in Alberta” (January 2009) Government of Alberta at 1 online: https://www.alberta.ca/provincial-air-quality-management.aspx",
      },
      {
        name: "Environmental Protection and Enhancement Act",
        citation:
          "[2] Environmental Protection and Enhancement Act, RSA 2000, e-12, s 2",
      },
      {
        name: "Environmental Protection and Enhancement Act",
        citation: "[3] Environmental Protection and Enhancement Act, s 2",
      },
      {
        name: "Environmental Protection and Enhancement Act",
        citation:
          "[4] Environmental Protection and Enhancement Act, ss 39(c), 43 & 44(1)",
      },
      {
        name: "Activities Designation Regulation",
        citation:
          "[5] Activities Designation Regulation, Alta Reg 276/2003, ss 2, 3 & 4",
      },
      {
        name: "Environmental Protection and Enhancement Act",
        citation:
          "[6] Environmental Protection and Enhancement Act, ss 108 & 109",
      },
      {
        name: "Environmental Protection and Enhancement Act",
        citation:
          "[7] Environmental Protection and Enhancement Act, ss 113, 129, 140 & 150",
      },
      {
        name: "Release Reporting Regulation",
        citation: "[8] Release Reporting Regulation, Alta Reg 117/1993",
      },
      {
        name: "Waste Control Regulation",
        citation: "[9] Waste Control Regulation, Alta Reg 192/1996",
      },
      "Waste Control Regulation (Alta Reg 192/1996)",
      "Release Reporting Regulation (Alta Reg 117/1993)",
      "Pesticide Sales, Handling, Use and Application Regulation (Alta Reg 24/1997)",
      "Water (Ministerial) Regulation (Alta Reg 205/1998)",
      "Public Lands Administration Regulation (Alta Reg 187/2011)",
      "Timber Management Regulation (Alta Reg 60/1973)",
      "Mines and Minerals Administration Regulation (Alta Reg 262/1997)",
      "Oil Sands Conservation Rules (Alta Reg 76/1988)",
      "Alberta Land Stewardship Regulation (Alta Reg 247/2011)",
      "Technology Innovation and Emissions Reduction Regulation (Alta Reg 133/2019)",
      "Wildlife Regulation (Alta Reg 143/1997)",
      "Coal Conservation Rules (Alta Reg 270/81)",
      "Oil and Gas Conservation Rules (Alta Reg 151/1971)",
      "Mineral Resource Development Regulation (Alta Reg 262/2021)",
      "Gas Resources Preservation Regulation (Alta Reg 241/1973)",
      "Renewable Electricity Regulation (Alta Reg 183/2016)",
    ],
  },
  {
    name: "British Columbia",
    legislation: [
      "Environmental Management Act (EMA), 2003",
      "Water Sustainability Act, 2016",
      "Forest and Range Practices Act (FRPA), 2002",
      "Wildlife Act, 1996",
      "Greenhouse Gas Reduction Targets Act, 2007",
      "Carbon Tax Act, 2008",
      "Clean Energy Act, 2010",
      "Heritage Conservation Act, 1996",
      "Oil and Gas Activities Act, 2008",
      "Integrated Pest Management Act, 2003",
      "Ecological Reserve Act, RSBC 1996",
      "Greenhouse Gas Industrial Reporting and Control Act, 2014",
      "Environmental Assessment Act, 2018",
      "Land Act, 1996",
      "Riparian Areas Protection Regulation, 2019",
      "Climate Change Accountability Act, 2007",
      "Carbon Tax Act, 2008 Last updated on April 9, 2025",
      "Zero-Emission Vehicles Act, 2019",
      "Climate Change Accountability Act, 2019",
      "Drinking Water Protection Act, 2001",
      "Water Protection Act, 1996",
      "Mines Act, 1996",
      "Wildfire Act, 2004",
      "Water Users’ Communities Act, 1996",
      "Fish and Seafood Act, 2015",
      "Ministry of Environment Act, 1996",
      "Protected Areas of British Columbia Act, 2000",
    ],
    regulations: [
      "Water Sustainability Regulation [Last amended July 8, 2024 by B.C. Reg. 184/2024]",
      "Forest Planning and Practices Regulation [Last amended July 15, 2024 by B.C. Reg. 221/2024]",
      "Wildlife Act General Regulation [Last amended June 25, 2024 by B.C. Reg. 161/2024]",
      "Carbon Tax Regulation [Last amended July 8, 2024 by B.C. Reg. 186/2024 and includes amendments by B.C. Reg. 210/2024]",
      "Clean or Renewable Resource Regulation [includes amendments up to B.C. Reg. 81/2011, May 6, 2011]",
      "Energy Resource Activities General Regulation [Last amended September 1, 2023 by B.C. Reg. 187/2023]",
      "Integrated Pest Management Regulation [Last amended March 5, 2024 by B.C. Reg. 41/2024]",
      "Greenhouse Gas Emission Reporting Regulation [Last amended July 8, 2024 by B.C. Reg. 185/2024]",
      "Land Act Regulation [Last amended March 30, 2022 by B.C. Reg. 76/2022]",
      "Riparian Areas Protection Regulation [Last amended February 10, 2023 by B.C. Reg. 32/2023]",
      "Drinking Water Protection Regulation [Last amended March 6, 2024 by B.C. Reg. 47/2024]",
      "Wildfire Regulation [Last amended April 1, 2024 by B.C. Reg. 62/2024 and includes amendments by B.C. Reg. 68/2024]",
    ],
  },
  {
    name: "Manitoba",
    legislation: [
      "The Environment Act, 1988",
      "The Dangerous Goods Handling and Transportation Act, 1987",
      "The Contaminated Sites Remediation Act, 1996",
      "The Water Protection Act, 2005",
      "The Ozone Depleting Substances Act, 1989-1990",
      "The Waste Reduction and Prevention (WRAP) Act, 1989-1990",
      "The Drinking Water Safety Act, 2002",
      "The Groundwater and Water Well Act, 2012",
      "The Water Rights Act, 1988",
      "The Water Resources Conservation Act, 2000",
      "The Ecological Reserves Act, 1987",
      "The Conservation Agreements Act, 1997",
      "The Efficiency Manitoba Act, 2017",
      "The Oil and Gas Act, 1993",
      "The East Side Traditional Lands Planning and Special Protected Areas Act, 2009",
      "The Endangered Species and Ecosystems Act, 1989-1990",
      "The Mines and Minerals Act, 1991-1992",
      "The Surface Rights Act, 1987-88",
    ],
    regulations: [
      "Classes of Development Regulation (Man. Reg. 164/88)",
      "Dangerous Goods Handling and Transportation Regulation (Man. Reg. 55/2003)",
      "Contaminated Sites Remediation Regulation (Man. Reg. 105/97)",
      "Water Protection Regulation (Man. Reg. 126/2005)",
      "Ozone Depleting Substances and Other Halocarbons Regulation (Man. Reg. 103/94)",
      "Waste Reduction and Prevention Regulation (Man. Reg. 10/93)",
      "Drinking Water Safety Regulation (Man. Reg. 41/2007)",
      "Groundwater and Water Well Regulation (Man. Reg. 214/2015)",
      "Water Rights Regulation (Man. Reg. 126/87)",
      "Water Resources Conservation Regulation, Man Reg 179/2010",
      "Eligible Conservation Agencies Regulation, Man Reg 152/98",
      "AgriInsurance Regulation, Man Reg 119/2020",
      "Drilling and Production Regulation (Man. Reg. 111/94)",
      "East Side Traditional Lands Planning Regulation (Man. Reg. 77/2011)",
      "Surface Rights Regulation (Man. Reg. 159/2000)",
    ],
  },
  {
    name: "New Brunswick",
    legislation: [
      "Clean Environment Act, 1973",
      "Clean Air Act, 1997",
      "Clean Water Act, 1989",
      "Climate Change Act, 2018",
      "Pesticide Control Act, P-8, 1973",
      "Unsightly Premises Act, U-1, 1985",
      "Heritage Conservation Act, H-4.05, 2010",
      "Fish and Wildlife Act, F-14.1, 1980",
      "Protected Natural Areas Act, P-19.01, 2003",
      "Regional Solid Waste Commissions Regulation, 1990",
    ],
    regulations: [
      "Environmental Impact Assessment Regulation, NB Reg 87-83",
      "Water Quality Regulation, NB Reg 82-126",
      "Petroleum Product Storage and Handling Regulation, NB Reg 87-97",
      "Air Quality Regulation, NB Reg 97-133",
      "Ozone Depleting Substances and Other Halocarbons Regulation, NB Reg 97-132",
      "Watercourse and Wetland Alteration Regulation, NB Reg 90-80",
      "Potable Water Regulation, NB Reg 93-203",
      "Reduction of Greenhouse Gas Emissions Climate Change Act, NB Reg 2021-43",
      "Penalties Regulation Climate Change Act, 2021-44, NB Reg 2021-44",
      "General Regulation, NB Reg 96-126",
      "Dangerous or Unsightly Premises and Property Regulation, NB Reg 2018-19",
      "General Regulation, NB Reg 2010-132",
      "Wildlife Refuges and Wildlife Management Areas Regulation, NB Reg 94-43",
      "Establishment of Protected Natural Areas Regulation, NB Reg 2003-8",
      "Protected Area Exemption Regulation, NB Reg 90-120",
    ],
  },
  {
    name: "Newfoundland and Labrador",
    legislation: [
      "Environmental Protection Act, 2002",
      "Wilderness and Ecological Reserves Act, RSNL 1990, c. W-9",
      "Water Resources Act, 2002",
      "Urban and Rural Planning Act, 2000",
      "Waste Management Regulations, 2003",
      "Climate Change Action Plan, 2005",
      "Forest Protection Act, 1990",
      "Endangered Species Act, 2004",
      "Wildlife Act, 1990",
      "FISHERIES RESTRUCTURING ACT, 2001",
    ],
    regulations: [
      "Environmental Assessment Regulations, 2003 (NLR 54/03)",
      "Pesticides Control Regulations, 2003 (NLR 57/03)",
      "Storage and Handling of Gasoline and Associated Products Regulations, 2003 (NLR 58/03)",
      "Air Pollution Control Regulations, 2004 (NLR 39/04)",
      "Environmental Control Water and Sewage Regulations, 2003 (NLR 65/03)",
      "Waste Management Regulations, 2003 (NLR 59/03)",
      "Endangered Species List Regulations (NLR 57/02)",
      "Wild Life Regulations (CNLR 1156/96)",
      "Fisheries Restructuring Act (RSNL 1990, c. F-14)",
    ],
  },
  {
    name: "Nova Scotia",
    legislation: [
      "Environment Act, 1994-1995",
      "Wilderness Areas Protection Act, 1998",
      "Environmental Goals and Sustainable Prosperity Act, 2007, as amended by 2012, c. 42",
      "Special Places Protection Act, RSNS 1989, c 438",
      "Crown Lands Act, 1989",
      "Forests Act, 1989",
      "Wildlife Act, 1989",
      "Non-essential Pesticides Control Act, 2010",
      "Importation of Hydraulic Fracturing Wastewater Prohibition Act, 2013",
      "Biodiversity Act, 2021",
      "Environmental Goals and Climate Change Reduction Act, 2021",
    ],
    regulations: [
      "Environmental Assessment Regulations (NS Reg 26/95)",
      "Solid Waste-Resource Management Regulations (NS Reg 25/96)",
      "Air Quality Regulations",
    ],
  },
  {
    name: "Ontario",
    legislation: [
      "Environmental Protection Act, 1990",
      "Environmental Assessment Act, 1990",
      "Clean Water Act, 2006",
      "Safe Drinking Water Act, 2002",
      "Greenbelt Act, 2005",
      "Ontario Water Resources Act, 1990",
      "Pesticides Act, 1990",
      "Nutrient Management Act, 2002",
      "Endangered Species Act, 2007",
      "Conservation Authorities Act, 1990",
      "Environmental Bill of Rights, 1993",
      "Provincial Parks and Conservation Reserves Act, 2006",
      "Lakes and Rivers Improvement Act, 1990",
      "Aggregate Resources Act, 1990",
      "Crown Forest Sustainability Act, 1994",
      "Fish and Wildlife Conservation Act, 1997",
      "Resource Recovery and Circular Economy Act, 2016",
      "Waste-Free Ontario Act, 2016",
    ],
    regulations: [
      "General – Waste Management (O. Reg. 347)",
      "Air Pollution – Local Air Quality (O. Reg. 419/05)",
      "General Regulation (O. Reg. 287/07)",
      "Drinking Water Systems Regulation (O. Reg. 170/03)",
      "Ontario Drinking Water Quality Standards (O. Reg. 169/03)",
      "Designation of Greenbelt Area (O. Reg. 59/05)",
      "General Regulation (O. Reg. 63/09)",
      "General Regulation (O. Reg. 267/03)",
      "General Regulation (O. Reg. 242/08)",
      "Development, Interference with Wetlands and Alterations to Shorelines and Watercourses (O. Reg. 97/04)",
      "General Regulation (O. Reg. 347/07)",
      "General Regulation (R.R.O. 1990, Reg. 854)",
      "General Regulation (O. Reg. 167/95)",
      "General Regulation (O. Reg. 665/98)",
      "General Regulation (O. Reg. 225/18)",
    ],
  },
  {
    name: "Prince Edward Island",
    legislation: [
      "Environmental Protection Act, 1988",
      "Water Act, 2017",
      "Planning Act, 1988",
      "Renewable Energy Act, 2005",
      "Pesticides Control Act, 1988",
      "Climate Leadership Act, 2018",
      "Net-Zero Carbon Act, 2019",
      "Wildlife Conservation Act, 1988",
      "Forest Management Act, 1988",
      "Water and Sewerage Act, 1988",
      "Fisheries Act, 1988",
    ],
    regulations: [
      "Watercourse and Wetland Protection Regulations (PEI Reg EC720/08)",
      "Ozone Layer Protection Regulations (PEI Reg EC619/94)",
      "Water Withdrawal Regulations (Consultation Draft)",
      "Subdivision and Development Regulations",
      "Province-Wide Minimum Development Standards Regulations",
      "Renewable Energy Designated Areas Regulations (PEI Reg EC766/05)",
      "Development Permit Regulations",
      "Pesticides Control Act Regulations (PEI Reg EC761/05)",
      "Climate Leadership Regulations (PEI Reg EC57/19)",
      "Wildlife Conservation Act General Regulations",
      "Wildlife Conservation Fund Regulations (PEI Reg EC170/09)",
      "Provincial Forests Regulations (PEI Reg EC484/00)",
      "Fisheries Act Regulations (PEI Reg EC873/95)",
    ],
  },
  {
    name: "Quebec",
    legislation: [
      "Environment Quality Act (EQA), 1972",
      "Sustainable Development Act, 2006",
      "Act Respecting the Conservation and Development of Wildlife, 1983",
      "Watercourses Act, 1992",
      "Mining Act, 1987",
      "Sustainable Forest Development Act, 2010",
      "Act Respecting Land Use Planning and Development, 1979 Updated to November 30, 2024",
      "Act respecting the preservation of agricultural land and agricultural activities, 1996",
      "Natural Heritage Conservation Act (NHCA), 2002",
    ],
    regulations: [
      "Regulation respecting the application of the Environment Quality Act, 2018 (q-2, r. 3)",
      "Clean Air Regulation (q-2, r. 4.1)",
      "Water Withdrawal and Protection Regulation, 2014 (Q-2, r. 35.2)",
      "Regulation respecting wildlife habitats (R.Q. C-61.1, r. 18)",
      "Regulation respecting the sustainable development of forests in the domain of the State (A-18.1, r. 0.01)",
      "Preservation of Agricultural Land and Agricultural Activities Regulation (c. P-41.1, r. 1)",
      "Regulation respecting certain transitional measures of the Act to amend the Natural Heritage Conservation Act and other provisions, CQLR c C-61.01, r 0.1",
    ],
  },
  {
    name: "Saskatchewan",
    legislation: [
      "Environmental Management and Protection Act, 2010",
      "Forest Resources Management Act, 1996",
      "Water Security Agency Act, 2013",
      "Wildlife Act, 1998",
      "Environmental Assessment Act, 1980 updated 2024, c.4",
      "Wildlife Habitat Protection Act, 1983",
      "Pest Control Products (Saskatchewan) Act, RSS 1978, c P-8",
      "Saskatchewan Environmental Code, 2015",
      "Saskatchewan Climate Change Strategy, 2017",
      "Provincial Lands Act, 2016",
      "Management and Reduction of Greenhouse Gases Act, 2010",
    ],
    regulations: [
      "The Environmental Management and Protection (General) Regulations Being Chapter E-10.22 Reg 1 (effective June 1, 2015)",
      "The Environmental Management and Protection (Saskatchewan Environmental Code Adoption) Regulations, RRS c E-10.22 Reg 2",
      "The Forest Resources Management Regulations being Chapter F-19.1 Reg 1",
      "The Forest Resources Management (Saskatchewan Environmental Code Adoption) Regulations, RRS c F-19.1 Reg 11",
      "The Water Security Agency Regulations being Chapter W-8.1 Reg 1",
      "The Wildlife Act, 1998 being Chapter W 13.12",
      "The Environmental Assessment Act being Chapter E-10.1",
      "The Pest Control Products Regulations, 2015 Being Chapter P-8 Reg 4",
      "The Provincial Lands (Agriculture) Regulations being Chapter P-31.1 Reg 1",
      "The Management and Reduction of Greenhouse Gases (General and Electricity Producer) Regulations being Chapter M-2.01 Reg 1",
    ],
  },
  {
    name: "Northwest Territories",
    legislation: [
      "Environmental Protection Act, 1988",
      "Environmental Rights Act, SNWT 2023,c.8",
      "Pesticide Act, 1990",
      "Waters Act, 2014",
      "Forest Management Act, 1998",
      "Forest Protection Act, 1988",
      "Wildlife Act, 2013",
      "Oil and Gas Operations Act, 2014",
      "Waste Reduction and Recovery Act, 2003",
      "Mackenzie Valley Resource Management Act, 1998",
      "Northwest Territories Lands Act, 2014",
    ],
    regulations: [
      "Pesticide Regulations (R.R.N.W.T. 1990, c.P-2)",
      "WATERS REGULATIONS R-019-2014",
      "Wildlife Act Phase 2 Regulations",
      "Oil and Gas Operations Regulations (N.W.T. Reg. 030-2014)",
      "Mackenzie Valley Land Use Regulations (SOR/98-429)",
      "Northwest Territories Lands Regulations (N.W.T. Reg. 018-2014)",
      "Northwest Territories Mining Regulations (SOR/2014-68)",
    ],
  },
  {
    name: "Yukon",
    legislation: [
      "Environment Act, 1991",
      "Waters Act, 2003",
      "Wildlife Act, 2002",
      "Forest Resources Act, 2008",
      "Clean Energy Act, 2022",
      "Waste Reduction and Recovery Act, 2003",
      "Oil and Gas Act, RSY 2002, c 162",
      "Species at Risk Act (Federal), 2002",
      "Yukon Environmental and Socio-economic Assessment Act (YESAA), 2003",
    ],
    regulations: [
      "Beverage Container Regulation (YOIC 1992/17)",
      "Solid Waste Regulation (YOIC 2003/58)",
      "Waters Regulation (YOIC 2003/58)",
      "Wildlife Regulation (Y.O.I.C. 2012/84)",
      "Forest Resources Regulation (YOIC 2010/171)",
      "Designated Materials Regulation (YOIC 2003/58)",
      "Oil and Gas Disposition Regulations, YOIC 1999/147",
      "Oil and Gas Drilling and Production Regulations, YOIC 2004/158",
      "Assessable Activities, Exceptions and Executive Committee Projects Regulations (SOR/2005-379)",
    ],
  },
  {
    name: "Nunavut",
    legislation: [
      "Environmental Protection Act, 1999 (adapted)",
      "Nunavut Waters and Nunavut Surface Rights Tribunal Act, 2002 (Federal)",
      "Wildlife Act, 2003",
      "Nunavut Planning and Project Assessment Act (NUPPAA), 2013",
      "Species at Risk Act (Federal), 2002",
    ],
    regulations: [
      "Nunavut Waters Regulations",
      "Nunavut Hunting Regulations 2022-2023",
      "Species at Risk Act (S.C. 2002, c. 29)",
    ],
  },
];

export const federalData = [
  {
    legislation: [
      "Canadian Environmental Assessment Agency (CEAA) Guidelines for Environmental Impact Assessments",
      "Impact Assessment Agency of Canada (IAAC) Technical Guidance Documents",
      "Canadian Environmental Quality Guidelines (CEQG)",
      "Canadian Ambient Air Quality Standards (CAAQS)",
      "CCME National Classification System for Contaminated Sites",
      "CCME Guidelines for Canadian Drinking Water Quality",
      "CCME Soil Quality Guidelines for Protection of Environmental and Human Health",
      "CCME Water Quality Guidelines for Protection of Aquatic Life",
      "CCME Canadian Sediment Quality Guidelines",
      "CCME Wastewater Management Guidelines",
      "Fisheries and Oceans Canada (DFO) Fisheries Protection Policy Statements",
      "Health Canada's Guidelines for Canadian Recreational Water Quality",
      "Health Canada's Guidance on Environmental Noise for New Residential Development",
      "Health Canada's Federal Contaminated Sites Risk Assessment Guidelines",
      "Health Canada's Human Health Risk Assessment for Contaminated Sites",
      "Environment and Climate Change Canada (ECCC) Best Practices for the Prevention of Pollution",
      "ECCC Code of Practice for the Management of PM2.5 Emissions",
      "ECCC Code of Practice for the Environmental Management of Road Salts",
      "ECCC Guidelines for Wildlife Surveys for Environmental Assessment",
      "Natural Resources Canada (NRCan) Environmental Protocols for Exploration Projects",
      "Canadian Biodiversity Strategy",
      "Canadian Wetland Inventory and Classification System",
      "Migratory Birds Convention Act – General Nesting Period Guidelines",
      "Species at Risk Public Registry – Recovery Strategies and Management Plans",
      "Transportation of Dangerous Goods (TDG) Guidelines",
      "Workplace Hazardous Materials Information System (WHMIS) Requirements",
      "CSA Z1000 Occupational Health and Safety Management Standard",
      "CSA Z1002 Hazard Identification and Elimination and Risk Assessment and Control",
      "CSA Z1006 Management of Work in Confined Spaces",
      "CSA Z1005 Workplace Incident Investigation",
      "CSA Z731 Emergency Preparedness and Response",
      "CSA ISO 45001 Occupational Health and Safety Management Systems",
      "CSA ISO 14001 Environmental Management Systems",
      "CSA S850 Design and Assessment of Buildings Subjected to Blast Loads",
      "CSA Plus 4012 Management of Contaminated Sites Technical Guide",
      "CSA N288 Series Environmental Protection at Nuclear Facilities",
      "ISO 14064 Greenhouse Gas Accounting and Verification",
      "ISO 26000 Guidance on Social Responsibility",
      "Canadian Dam Association (CDA) Dam Safety Guidelines",
      "National Fire Code of Canada (NFCC)",
      "National Building Code of Canada (NBCC) – Health and Safety Provisions",
      "Canadian Best Practices Portal for Health Promotion",
      "PHAC Workplace Health Guidelines",
      "PHAC Canadian Pandemic Influenza Preparedness Guidelines",
      "Canadian Electricity Association Sustainable Electricity Standard",
      "Mining Association of Canada Towards Sustainable Mining (TSM) Protocols",
      "Energy Utilities Environmental Code of Practice",
      "Parks Canada Environmental Impact Assessment Guidelines",
      "Parks Canada Ecological Integrity Monitoring Guidelines",
      "Greenhouse Gas Emissions Reporting Technical Guidance",
      "Federal Contaminated Sites Action Plan (FCSAP) Risk Assessment Guidance",
      "CSA CAN/CSA-ISO 14064-1 GHG Quantification and Reporting",
      "CSA Z773 Environmental Management of Petroleum and Petrochemical Sites",
      "CSA W203 Erosion and Sediment Control Standard",
      "CSA S900.1 Sustainable Forest Management Requirements",
      "IFC Performance Standards (applicable for international project financing)",
      "Equator Principles (for project financing ESG requirements)",
      "World Bank Environmental, Health and Safety (EHS) Guidelines",
      "Pan-Canadian Framework on Clean Growth and Climate Change",
      "National Adaptation Strategy (Canada)",
      "Canadian Wildfire Management Strategy",
      "Canadian Arctic Policy Framework – Environmental and Social Guidelines",
      "Indigenous Consultation Guidelines for Environmental Assessments",
      "Duty to Consult and Accommodate Guidelines",
      "Accessibility Standards Canada Accessibility Guidelines",
      "Canadian Accessibility Standards for Employment",
      "Climate Lens Assessment Guidance",
      "Green Infrastructure Standards",
      "Canadian Principles for Sustainable Infrastructure",
      "CSA SPE-890 Site Decommissioning for Oil and Gas",
      "CSA Z741 Decommissioning Facilities Containing Hazardous Materials",
      "CSA Z1600 Emergency and Continuity Management Program",
      "CSA Z1003 Psychological Health and Safety in the Workplace",
      "Canadian Construction Association Environmental Best Practices Guide",
      "Mining Industry Human Resources Council Indigenous Engagement Guidelines",
      "Electricity Canada Environmental Commitment and Responsibility Program (ECRP)",
      "Canadian Renewable Energy Association Environmental Stewardship Guidelines",
      "TCFD Climate Risk Disclosure Standards",
      "Canadian Corporate Social Responsibility (CSR) Voluntary Guidelines",
      "National Environmental Emergency (E2) Guidelines",
    ],
    regulations: [
      {
        name: "Alberta",
        subRegulations: [
          "Alberta Air Management Framework",
          "Alberta Environmental Site Assessment Guidelines",
          "Alberta Tier 1 and Tier 2 Soil and Groundwater Remediation Guidelines",
          "Alberta Energy Regulator (AER) Directives on Health, Safety, Environment",
          "Alberta Traffic Safety Plan and Best Practices for Industry",
          "Alberta Occupational Health and Safety Code",
        ],
      },
      {
        name: "British Columbia",
        subRegulations: [
          "BC Environmental Best Management Practices Series",
          "British Columbia Site Profile Guidance for Contaminated Sites",
          "BC Environmental Protection Division Technical Guidance",
          "BC Workers Compensation Act and OHS Regulation",
        ],
      },
      {
        name: "Manitoba",
        subRegulations: [
          "Manitoba Contaminated Sites Remediation Guidelines",
          "Manitoba Environmental Impact Assessment Technical Guidelines",
          "Manitoba Workplace Safety and Health Act and Regulations",
        ],
      },
      {
        name: "New Brunswick",
        subRegulations: [
          "New Brunswick Environmental Assessment and Clean Air Guidance",
          "New Brunswick Occupational Health and Safety Act",
        ],
      },
      {
        name: "Newfoundland and Labrador",
        subRegulations: [
          "Newfoundland Environmental Assessment Procedures Manual",
          "Newfoundland and Labrador Occupational Health and Safety Regulations",
        ],
      },
      {
        name: "Nova Scotia",
        subRegulations: [
          "Nova Scotia Environmental Assessment Regulations Guidance",
          "Nova Scotia Occupational Health and Safety Act",
        ],
      },
      {
        name: "Ontario",
        subRegulations: [
          "Ontario Environmental Site Assessment Standard (O. Reg. 153/04 Protocols)",
          "Ontario Environmental Noise Guidelines (NPC Series)",
          "Ontario Technical Standards and Safety Authority (TSSA) Environmental Health Guidelines",
          "Ontario Occupational Health and Safety Act (OHSA)",
        ],
      },
      {
        name: "Prince Edward Island",
        subRegulations: [
          "PEI Contaminated Sites Guidelines",
          "PEI Occupational Health and Safety Act",
        ],
      },
      {
        name: "Quebec",
        subRegulations: [
          "Quebec Environmental Assessment Directive",
          "Quebec Soil Protection and Contaminated Sites Remediation Policy",
          "Quebec Act Respecting Occupational Health and Safety (AOHS)",
          "Quebec Building Chapter Safety Code (Chapter I – Building)",
        ],
      },
      {
        name: "Saskatchewan",
        subRegulations: [
          "Saskatchewan Environmental Code",
          "Saskatchewan Technical Guidelines for Environmental Site Assessment and Remediation",
          "Saskatchewan Occupational Health and Safety Regulations",
        ],
      },
      {
        name: "Northwest Territories",
        subRegulations: [
          "Northern Land Use Guidelines (Industrial Development)",
          "NWT Safety Act and Occupational Health and Safety Regulations",
        ],
      },
      {
        name: "Yukon",
        subRegulations: [
          "Yukon Environmental Assessment Guidelines (YESAA)",
          "Yukon Occupational Health and Safety Act and Regulations",
        ],
      },
      {
        name: "Nunavut",
        subRegulations: [
          "Nunavut Environmental Impact Assessment Guidelines",
          "Nunavut Safety Act and OHS Regulations (via WSCC)",
        ],
      },
    ],
  },
];

export const federalRegulations = [
  {
    name: "Alberta",
    legislation: [
      "Environmental Protection and Enhancement Act (EPEA), 1992",
      "Water Act, 1999",
      "Climate Change and Emissions Management Act, 2003",
      "Public Lands Act, 2000",
      "Forests Act, R.S.A. 2000, c. F-22",
      "Mines and Minerals Act, 2000",
      "Oil Sands Conservation Act, 2000",
      "Alberta Land Stewardship Act (ALSA), 2009",
      "Emissions Management and Climate Resilience Act, 2023",
      "Wildlife Act, 1984, R.S.A. 2000, c. W-10",
      "Fisheries (Alberta) Act, R.S.A. 2000, c. F-16",
      "Coal Conservation Act, R.S.A. 2000, c. C-17",
      "Oil and Gas Conservation Act, R.S.A. 2000, c. O-6",
      "Mineral Resource Development Act, 2021, c M-16.8",
      "Gas Resources Preservation Act, R.S.A. 2000, c. G-4",
      "Renewable Electricity Act, 2016",
    ],
    regulations: [
      "Air Policy Sector, “Air Management in Alberta” (January 2009) Government of Alberta at 1 online: https://www.alberta.ca/provincial-air-quality-management.aspx",
      "Environmental Protection and Enhancement Act, RSA 2000, e-12, s 2",
      "Environmental Protection and Enhancement Act, s 2",
      "Environmental Protection and Enhancement Act, ss 39(c), 43 & 44(1)",
      "Activities Designation Regulation, Alta Reg 276/2003, ss 2, 3 & 4",
      "Environmental Protection and Enhancement Act, ss 108 & 109",
      "Environmental Protection and Enhancement Act, ss 113, 129, 140 & 150",
      "Release Reporting Regulation, Alta Reg 117/1993",
      "Waste Control Regulation, Alta Reg 192/1996",
      "Pesticide Sales, Handling, Use and Application Regulation, Alta Reg 24/1997",
      "Water (Ministerial) Regulation, Alta Reg 205/1998",
      "Public Lands Administration Regulation, Alta Reg 187/2011",
      "Timber Management Regulation, Alta Reg 60/1973",
      "Mines and Minerals Administration Regulation, Alta Reg 262/1997",
      "Oil Sands Conservation Rules, Alta Reg 76/1988",
      "Alberta Land Stewardship Regulation, Alta Reg 247/2011",
      "Technology Innovation and Emissions Reduction Regulation, Alta Reg 133/2019",
      "Wildlife Regulation, Alta Reg 143/1997",
      "Coal Conservation Rules, Alta Reg 270/81",
      "Oil and Gas Conservation Rules, Alta Reg 151/1971",
      "Mineral Resource Development Regulation, Alta Reg 262/2021",
      "Gas Resources Preservation Regulation, Alta Reg 241/1973",
      "Renewable Electricity Regulation, Alta Reg 183/2016",
    ],
  },
  {
    name: "British Columbia",
    legislation: [
      "Environmental Management Act (EMA), 2003",
      "Water Sustainability Act, 2016",
      "Forest and Range Practices Act (FRPA), 2002",
      "Wildlife Act, 1996",
      "Greenhouse Gas Reduction Targets Act, 2007",
      "Carbon Tax Act, 2008",
      "Clean Energy Act, 2010",
      "Heritage Conservation Act, 1996",
      "Oil and Gas Activities Act, 2008",
      "Integrated Pest Management Act, 2003",
      "Ecological Reserve Act, RSBC 1996",
      "Greenhouse Gas Industrial Reporting and Control Act, 2014",
      "Environmental Assessment Act, 2018",
      "Land Act, 1996",
      "Riparian Areas Protection Regulation, 2019",
      "Climate Change Accountability Act, 2007",
      "Climate Change Accountability Act, 2019",
      "Drinking Water Protection Act, 2001",
      "Water Protection Act, 1996",
      "Mines Act, 1996",
      "Wildfire Act, 2004",
      "Water Users’ Communities Act, 1996",
      "Fish and Seafood Act, 2015",
      "Ministry of Environment Act, 1996",
      "Protected Areas of British Columbia Act, 2000",
    ],
    regulations: [
      "Water Sustainability Regulation [Last amended July 8, 2024 by B.C. Reg. 184/2024]",
      "Forest Planning and Practices Regulation [Last amended July 15, 2024 by B.C. Reg. 221/2024]",
      "Wildlife Act General Regulation [Last amended June 25, 2024 by B.C. Reg. 161/2024]",
      "Carbon Tax Regulation [Last amended July 8, 2024 by B.C. Reg. 186/2024 and includes amendments by B.C. Reg. 210/2024]",
      "Clean or Renewable Resource Regulation [includes amendments up to B.C. Reg. 81/2011, May 6, 2011]",
      "Energy Resource Activities General Regulation [Last amended September 1, 2023 by B.C. Reg. 187/2023]",
      "Integrated Pest Management Regulation [Last amended March 5, 2024 by B.C. Reg. 41/2024]",
      "Greenhouse Gas Emission Reporting Regulation [Last amended July 8, 2024 by B.C. Reg. 185/2024]",
      "Land Act Regulation [Last amended March 30, 2022 by B.C. Reg. 76/2022]",
      "Riparian Areas Protection Regulation [Last amended February 10, 2023 by B.C. Reg. 32/2023]",
      "Drinking Water Protection Regulation [Last amended March 6, 2024 by B.C. Reg. 47/2024]",
      "Wildfire Regulation [Last amended April 1, 2024 by B.C. Reg. 62/2024 and includes amendments by B.C. Reg. 68/2024]",
    ],
  },
  {
    name: "Manitoba",
    legislation: [
      "The Environment Act, 1988",
      "The Dangerous Goods Handling and Transportation Act, 1987",
      "The Contaminated Sites Remediation Act, 1996",
      "The Water Protection Act, 2005",
      "The Ozone Depleting Substances Act, 1989-1990",
      "The Waste Reduction and Prevention (WRAP) Act, 1989-1990",
      "The Drinking Water Safety Act, 2002",
      "The Groundwater and Water Well Act, 2012",
      "The Water Rights Act, 1988",
      "The Water Resources Conservation Act, 2000",
      "The Ecological Reserves Act, 1987",
      "The Conservation Agreements Act, 1997",
      "The Efficiency Manitoba Act, 2017",
      "The Oil and Gas Act, 1993",
      "The East Side Traditional Lands Planning and Special Protected Areas Act, 2009",
      "The Endangered Species and Ecosystems Act, 1989-1990",
      "The Mines and Minerals Act, 1991-1992",
      "The Surface Rights Act, 1987-88",
    ],
    regulations: [
      "Classes of Development Regulation (Man. Reg. 164/88)",
      "Dangerous Goods Handling and Transportation Regulation (Man. Reg. 55/2003)",
      "Contaminated Sites Remediation Regulation (Man. Reg. 105/97)",
      "Water Protection Regulation (Man. Reg. 126/2005)",
      "Ozone Depleting Substances and Other Halocarbons Regulation (Man. Reg. 103/94)",
      "Waste Reduction and Prevention Regulation (Man. Reg. 10/93)",
      "Drinking Water Safety Regulation (Man. Reg. 41/2007)",
      "Groundwater and Water Well Regulation (Man. Reg. 214/2015)",
      "Water Rights Regulation (Man. Reg. 126/87)",
      "Water Resources Conservation Regulation, Man Reg 179/2010",
      "Eligible Conservation Agencies Regulation, Man Reg 152/98",
      "AgriInsurance Regulation, Man Reg 119/2020",
      "Drilling and Production Regulation (Man. Reg. 111/94)",
      "East Side Traditional Lands Planning Regulation (Man. Reg. 77/2011)",
      "Surface Rights Regulation (Man. Reg. 159/2000)",
    ],
  },
  {
    name: "New Brunswick",
    legislation: [
      "Clean Environment Act, 1973",
      "Clean Air Act, 1997",
      "Clean Water Act, 1989",
      "Climate Change Act, 2018",
      "Pesticide Control Act, P-8, 1973",
      "Unsightly Premises Act, U-1, 1985",
      "Heritage Conservation Act, H-4.05, 2010",
      "Fish and Wildlife Act, F-14.1, 1980",
      "Protected Natural Areas Act, P-19.01, 2003",
      "Regional Solid Waste Commissions Regulation, 1990",
    ],
    regulations: [
      "Environmental Impact Assessment Regulation, NB Reg 87-83",
      "Water Quality Regulation, NB Reg 82-126",
      "Petroleum Product Storage and Handling Regulation, NB Reg 87-97",
      "Air Quality Regulation, NB Reg 97-133",
      "Ozone Depleting Substances and Other Halocarbons Regulation, NB Reg 97-132",
      "Watercourse and Wetland Alteration Regulation, NB Reg 90-80",
      "Potable Water Regulation, NB Reg 93-203",
      "Reduction of Greenhouse Gas Emissions Climate Change Act, NB Reg 2021-43",
      "Penalties Regulation Climate Change Act, 2021-44, NB Reg 2021-44",
      "General Regulation, NB Reg 96-126",
      "Dangerous or Unsightly Premises and Property Regulation, NB Reg 2018-19",
      "General Regulation, NB Reg 2010-132",
      "Wildlife Refuges and Wildlife Management Areas Regulation, NB Reg 94-43",
      "Establishment of Protected Natural Areas Regulation, NB Reg 2003-8",
      "Protected Area Exemption Regulation, NB Reg 90-120",
    ],
  },
  {
    name: "Newfoundland and Labrador",
    legislation: [
      "Environmental Protection Act, 2002",
      "Wilderness and Ecological Reserves Act, RSNL 1990, c. W-9",
      "Water Resources Act, 2002",
      "Urban and Rural Planning Act, 2000",
      "Waste Management Regulations, 2003",
      "Climate Change Action Plan, 2005",
      "Forest Protection Act, 1990",
      "Endangered Species Act, 2004",
      "Wildlife Act, 1990",
      "Fisheries Restructuring Act, 2001",
    ],
    regulations: [
      "Environmental Assessment Regulations, 2003 (NLR 54/03)",
      "Pesticides Control Regulations, 2003 (NLR 57/03)",
      "Storage and Handling of Gasoline and Associated Products Regulations, 2003 (NLR 58/03)",
      "Air Pollution Control Regulations, 2004 (NLR 39/04)",
      "Environmental Control Water and Sewage Regulations, 2003 (NLR 65/03)",
      "Waste Management Regulations, 2003 (NLR 59/03)",
      "Endangered Species List Regulations (NLR 57/02)",
      "Wild Life Regulations (CNLR 1156/96)",
    ],
  },
  {
    name: "Nova Scotia",
    legislation: [
      "Environment Act, 1994-1995",
      "Wilderness Areas Protection Act, 1998",
      "Environmental Goals and Sustainable Prosperity Act, 2007, as amended by 2012, c. 42",
      "Special Places Protection Act, RSNS 1989, c 438",
      "Crown Lands Act, 1989",
      "Forests Act, 1989",
      "Wildlife Act, 1989",
      "Non-essential Pesticides Control Act, 2010",
      "Importation of Hydraulic Fracturing Wastewater Prohibition Act, 2013",
      "Biodiversity Act, 2021",
      "Environmental Goals and Climate Change Reduction Act, 2021",
    ],
    regulations: [
      "Environmental Assessment Regulations (NS Reg 26/95)",
      "Solid Waste-Resource Management Regulations (NS Reg 25/96)",
      "Air Quality Regulations",
    ],
  },
  {
    name: "Ontario",
    legislation: [
      "Environmental Protection Act, 1990",
      "Environmental Assessment Act, 1990",
      "Clean Water Act, 2006",
      "Safe Drinking Water Act, 2002",
      "Greenbelt Act, 2005",
      "Ontario Water Resources Act, 1990",
      "Pesticides Act, 1990",
      "Nutrient Management Act, 2002",
      "Endangered Species Act, 2007",
      "Conservation Authorities Act, 1990",
      "Environmental Bill of Rights, 1993",
      "Provincial Parks and Conservation Reserves Act, 2006",
      "Lakes and Rivers Improvement Act, 1990",
      "Aggregate Resources Act, 1990",
      "Crown Forest Sustainability Act, 1994",
      "Fish and Wildlife Conservation Act, 1997",
      "Resource Recovery and Circular Economy Act, 2016",
      "Waste-Free Ontario Act, 2016",
    ],
    regulations: [
      "General – Waste Management (O. Reg. 347)",
      "Air Pollution – Local Air Quality (O. Reg. 419/05)",
      "General Regulation (O. Reg. 287/07)",
      "Drinking Water Systems Regulation (O. Reg. 170/03)",
      "Ontario Drinking Water Quality Standards (O. Reg. 169/03)",
      "Designation of Greenbelt Area (O. Reg. 59/05)",
      "General Regulation (O. Reg. 63/09)",
      "General Regulation (O. Reg. 267/03)",
      "General Regulation (O. Reg. 242/08)",
      "Development, Interference with Wetlands and Alterations to Shorelines and Watercourses (O. Reg. 97/04)",
      "General Regulation (O. Reg. 347/07)",
      "General Regulation (O. Reg. 167/95)",
      "General Regulation (O. Reg. 665/98)",
      "General Regulation (O. Reg. 225/18)",
    ],
  },
  {
    name: "Prince Edward Island",
    legislation: [
      "Environmental Protection Act, 1988",
      "Water Act, 2017",
      "Planning Act, 1988",
      "Renewable Energy Act, 2005",
      "Pesticides Control Act, 1988",
      "Climate Leadership Act, 2018",
      "Net-Zero Carbon Act, 2019",
      "Wildlife Conservation Act, 1988",
      "Forest Management Act, 1988",
      "Water and Sewerage Act, 1988",
      "Fisheries Act, 1988",
    ],
    regulations: [
      "Watercourse and Wetland Protection Regulations (PEI Reg EC720/08)",
      "Ozone Layer Protection Regulations (PEI Reg EC619/94)",
      "Water Withdrawal Regulations (Consultation Draft)",
      "Subdivision and Development Regulations",
      "Province-Wide Minimum Development Standards Regulations",
      "Renewable Energy Designated Areas Regulations (PEI Reg EC766/05)",
      "Development Permit Regulations",
      "Pesticides Control Act Regulations (PEI Reg EC761/05)",
      "Climate Leadership Regulations (PEI Reg EC57/19)",
      "Wildlife Conservation Act General Regulations",
      "Wildlife Conservation Fund Regulations (PEI Reg EC170/09)",
      "Provincial Forests Regulations (PEI Reg EC484/00)",
      "Fisheries Act Regulations (PEI Reg EC873/95)",
    ],
  },
  {
    name: "Quebec",
    legislation: [
      "Environment Quality Act (EQA), 1972",
      "Sustainable Development Act, 2006",
      "Act Respecting the Conservation and Development of Wildlife, 1983",
      "Watercourses Act, 1992",
      "Mining Act, 1987",
      "Sustainable Forest Development Act, 2010",
      "Act Respecting Land Use Planning and Development, 1979",
      "Act respecting the preservation of agricultural land and agricultural activities, 1996",
      "Natural Heritage Conservation Act (NHCA), 2002",
    ],
    regulations: [
      "Regulation respecting the application of the Environment Quality Act, 2018 (q-2, r. 3)",
      "Clean Air Regulation (q-2, r. 4.1)",
      "Water Withdrawal and Protection Regulation, 2014 (Q-2, r. 35.2)",
      "Regulation respecting wildlife habitats (R.Q. C-61.1, r. 18)",
      "Regulation respecting the sustainable development of forests in the domain of the State (A-18.1, r. 0.01)",
      "Preservation of Agricultural Land and Agricultural Activities Regulation (c. P-41.1, r. 1)",
      "Regulation respecting certain transitional measures of the Act to amend the Natural Heritage Conservation Act and other provisions, CQLR c C-61.01, r 0.1",
    ],
  },
  {
    name: "Saskatchewan",
    legislation: [
      "Environmental Management and Protection Act, 2010",
      "Forest Resources Management Act, 1996",
      "Water Security Agency Act, 2013",
      "Wildlife Act, 1998",
      "Environmental Assessment Act, 1980 updated 2024, c.4",
      "Wildlife Habitat Protection Act, 1983",
      "Pest Control Products (Saskatchewan) Act, RSS 1978, c P-8",
      "Saskatchewan Environmental Code, 2015",
      "Saskatchewan Climate Change Strategy, 2017",
      "Provincial Lands Act, 2016",
      "Management and Reduction of Greenhouse Gases Act, 2010",
    ],
    regulations: [
      "The Environmental Management and Protection (General) Regulations, Chapter E-10.22 Reg 1",
      "The Environmental Management and Protection (Saskatchewan Environmental Code Adoption) Regulations, RRS c E-10.22 Reg 2",
      "The Forest Resources Management Regulations, Chapter F-19.1 Reg 1",
      "The Forest Resources Management (Saskatchewan Environmental Code Adoption) Regulations, RRS c F-19.1 Reg 11",
      "The Water Security Agency Regulations, Chapter W-8.1 Reg 1",
      "The Environmental Assessment Act, Chapter E-10.1",
      "The Pest Control Products Regulations, 2015, Chapter P-8 Reg 4",
      "The Provincial Lands (Agriculture) Regulations, Chapter P-31.1 Reg 1",
      "The Management and Reduction of Greenhouse Gases (General and Electricity Producer) Regulations, Chapter M-2.01 Reg 1",
    ],
  },
  {
    name: "Northwest Territories",
    legislation: [
      "Environmental Protection Act, 1988",
      "Environmental Rights Act, SNWT 2023, c.8",
      "Pesticide Act, 1990",
      "Waters Act, 2014",
      "Forest Management Act, 1998",
      "Forest Protection Act, 1988",
      "Wildlife Act, 2013",
      "Oil and Gas Operations Act, 2014",
      "Waste Reduction and Recovery Act, 2003",
      "Mackenzie Valley Resource Management Act, 1998",
      "Northwest Territories Lands Act, 2014",
    ],
    regulations: [
      "Pesticide Regulations (R.R.N.W.T. 1990, c.P-2)",
      "Waters Regulations (R-019-2014)",
      "Wildlife Act Phase 2 Regulations",
      "Oil and Gas Operations Regulations (N.W.T. Reg. 030-2014)",
      "Mackenzie Valley Land Use Regulations (SOR/98-429)",
      "Northwest Territories Lands Regulations (N.W.T. Reg. 018-2014)",
      "Northwest Territories Mining Regulations (SOR/2014-68)",
    ],
  },
  {
    name: "Yukon",
    legislation: [
      "Environment Act, 1991",
      "Waters Act, 2003",
      "Wildlife Act, 2002",
      "Forest Resources Act, 2008",
      "Clean Energy Act, 2022",
      "Waste Reduction and Recovery Act, 2003",
      "Oil and Gas Act, RSY 2002, c 162",
      "Species at Risk Act (Federal), 2002",
      "Yukon Environmental and Socio-economic Assessment Act (YESAA), 2003",
    ],
    regulations: [
      "Beverage Container Regulation (YOIC 1992/17)",
      "Solid Waste Regulation (YOIC 2003/58)",
      "Waters Regulation (YOIC 2003/58)",
      "Wildlife Regulation (Y.O.I.C. 2012/84)",
      "Forest Resources Regulation (YOIC 2010/171)",
      "Designated Materials Regulation (YOIC 2003/58)",
      "Oil and Gas Disposition Regulations, YOIC 1999/147",
      "Oil and Gas Drilling and Production Regulations, YOIC 2004/158",
      "Assessable Activities, Exceptions and Executive Committee Projects Regulations (SOR/2005-379)",
    ],
  },
  {
    name: "Nunavut",
    legislation: [
      "Environmental Protection Act, 1999 (adapted)",
      "Nunavut Waters and Nunavut Surface Rights Tribunal Act, 2002 (Federal)",
      "Wildlife Act, 2003",
      "Nunavut Planning and Project Assessment Act (NUPPAA), 2013",
      "Species at Risk Act (Federal), 2002",
    ],
    regulations: [
      "Nunavut Waters Regulations",
      "Nunavut Hunting Regulations 2022-2023",
      "Species at Risk Act (S.C. 2002, c. 29)",
    ],
  },
];
